import { App, ConfigProvider } from 'antd';
import type { TableConfig, TagConfig } from 'antd/es/config-provider/context';
import { THEME } from './antd-provider.constants';
import { useLocale } from './antd-provider.use-locale';

interface AntdProviderProps {
  children: React.ReactNode;
}

const TURN_OFF_BLUR_EFFECT = { mask: { blur: false } };

const TABLE: TableConfig = {
  styles: {
    header: {
      cell: {
        overflowWrap: 'initial'
      }
    }
  }
};

const TAG: TagConfig = {
  variant: 'solid'
};

const AntdProvider = ({ children }: AntdProviderProps) => {
  const locale = useLocale();
  return (
    <ConfigProvider locale={locale} theme={THEME} modal={TURN_OFF_BLUR_EFFECT} drawer={TURN_OFF_BLUR_EFFECT} table={TABLE} tag={TAG}>
      <App>{children}</App>
    </ConfigProvider>
  );
};

export default AntdProvider;
